webpackJsonp([167925855539571],{

/***/ 552:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactJss = __webpack_require__(8);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _gatsbyLink = __webpack_require__(18);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Main = __webpack_require__(40);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	var _Article = __webpack_require__(39);
	
	var _Article2 = _interopRequireDefault(_Article);
	
	var _PageHeader = __webpack_require__(45);
	
	var _PageHeader2 = _interopRequireDefault(_PageHeader);
	
	var _Content = __webpack_require__(44);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _Seo = __webpack_require__(76);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _Footer = __webpack_require__(105);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  return {};
	};
	
	var TopThree = function TopThree() {
	  var _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11;
	
	  var data = {
	    frontmatter: {
	      title: "Best surf helmets",
	      description: "The top 3 best surf helmets currently available, considering impact protection and surfing performance.  All helmets tried and tested.  All applicable helmet technologies researched and referenced.  There's no better resource on the internet comparing what's available now and what could be, gauranteed.  If you're looking for the right surf helmet, you've found the right place."
	    }
	  };
	  var facebook = {};
	  return _react2.default.createElement(
	    _Main2.default,
	    null,
	    _react2.default.createElement(
	      _Article2.default,
	      null,
	      _react2.default.createElement(_PageHeader2.default, { title: "Best surf helmets", subTitle: "The top 3 and runner-ups in 2024" }),
	      _react2.default.createElement(
	        _Content2.default,
	        null,
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Gamebreaker-PRO with D3O: The best all around"
	        ),
	        _react2.default.createElement("img", {
	          src: "https://res.cloudinary.com/dx1tmklnq/image/upload/w_1000,c_scale/v1562895574/project_surf_helmet/IMG_20190711_181020_fj5zeu.jpg",
	          style: { width: "100%", margin: "0 0 1.5em 0" }
	        }),
	        _react2.default.createElement(
	          "table",
	          null,
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              null,
	              "Pros"
	            ),
	            _react2.default.createElement(
	              "th",
	              null,
	              "Cons"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              null,
	              "Light, minimal"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "Water drips in eyes"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              null,
	              "Stays on your head"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "Takes on a tad bit of water"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              null,
	              "5-star protection according to",
	              " ",
	              _react2.default.createElement(
	                "a",
	                { href: "https://helmet.beam.vt.edu/soccer-headgear-ratings.html", target: "_blank" },
	                "Virginia Tech\u2019s Helmet Lab"
	              )
	            ),
	            _react2.default.createElement("td", null)
	          )
	        ),
	        _react2.default.createElement(
	          "strong",
	          null,
	          "Recommendation"
	        ),
	        ": Good performance and protection. My top recommendation currently on the market. A recent study shows it",
	        " ",
	        _react2.default.createElement(
	          "a",
	          { target: "_blank", href: "https://pubmed.ncbi.nlm.nih.gov/33981403/" },
	          "outperforms"
	        ),
	        " ",
	        "other soft-shell helmets. ",
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: "/reviews/gamebreaker-pro-d3o/" },
	          "Full review"
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              marginTop: "30px",
	              marginBottom: "15px",
	              width: "100%",
	              paddingBottom: "45px",
	              borderBottom: "1px solid #ccc"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            { style: { margin: "0 auto", width: "max-content" } },
	            _react2.default.createElement(
	              "a",
	              {
	                href: "https://gamebreaker.com/shop/gamebreaker-pro-soft-shell-sports-helmet",
	                target: "_blank",
	                style: (_ref = {
	                  borderRadius: "4px",
	                  border: "none",
	                  textAlign: "center",
	                  cursor: "pointer",
	                  fontSize: "16px",
	                  msFlexItemAlign: "center",
	                  msGridRowAlign: "center",
	                  alignSelf: "center",
	                  outline: "none",
	                  fontFamily: "inherit",
	                  fontWeight: 500
	                }, _ref["textAlign"] = "center", _ref.paddingLeft = "20px", _ref.paddingRight = "20px", _ref.height = "45px", _ref.minWidth = "100px", _ref.backgroundColor = "inherit", _ref.color = "#010101", _ref["border"] = "1px solid #010101", _ref["fontWeight"] = 600, _ref.textDecoration = "none", _ref.paddingTop = "7.5px", _ref.paddingBottom = "8.5px", _ref)
	              },
	              "Order direct"
	            ),
	            _react2.default.createElement(
	              "a",
	              {
	                href: "https://amzn.to/2ZGAgAn",
	                target: "_blank",
	                style: (_ref2 = {
	                  color: "white",
	                  borderRadius: "4px",
	                  border: "none",
	                  textAlign: "center",
	                  cursor: "pointer",
	                  fontSize: "16px",
	                  msFlexItemAlign: "center",
	                  msGridRowAlign: "center",
	                  alignSelf: "center",
	                  outline: "none",
	                  fontFamily: "inherit",
	                  fontWeight: 500
	                }, _ref2["textAlign"] = "center", _ref2.paddingLeft = "20px", _ref2.paddingRight = "20px", _ref2.height = "47px", _ref2.minWidth = "100px", _ref2.backgroundColor = "#ee5a5a", _ref2.marginLeft = "30px", _ref2["fontWeight"] = 600, _ref2.textDecoration = "none", _ref2.paddingTop = "9px", _ref2.paddingBottom = "10px", _ref2)
	              },
	              "Amazon price"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Olaian Surf Helmet: The best small wave helmet"
	        ),
	        _react2.default.createElement("img", {
	          src: "https://res.cloudinary.com/dx1tmklnq/image/upload/w_1000,c_scale/v1581132019/project_surf_helmet/20230710_184716_2_zg4xvx.jpg",
	          style: { width: "100%", margin: "0 0 1.5em 0" }
	        }),
	        _react2.default.createElement(
	          "table",
	          null,
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              null,
	              "Pros"
	            ),
	            _react2.default.createElement(
	              "th",
	              null,
	              "Cons"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              null,
	              "Surfer look"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "Slides back due to bucket effect"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              null,
	              "PU Foam"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "No sun protection"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              null,
	              "Light, minimal, comfortable"
	            ),
	            _react2.default.createElement("td", null)
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              null,
	              "Deflects water from eyes"
	            ),
	            _react2.default.createElement("td", null)
	          )
	        ),
	        _react2.default.createElement(
	          "strong",
	          null,
	          "Recommendation"
	        ),
	        ": While the new Olaian Surf Helmet by Decathlon looks good and provides adequate protection, Decathlon has made a couple of design choices that prevent it from performing exceptionally. However, despite its faults, it is still a great option. ",
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: "/reviews/olaian-surf-helmet/" },
	          "Full review"
	        ),
	        ".",
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              marginTop: "30px",
	              marginBottom: "15px",
	              width: "100%",
	              paddingBottom: "45px",
	              borderBottom: "1px solid #ccc"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            { style: { margin: "0 auto", width: "max-content" } },
	            _react2.default.createElement(
	              "a",
	              {
	                href: "https://www.decathlon.com/collections/surf-accessories-spare-parts/products/decathlon-water-sports-surfing-wake-foiling-kitesurfing-paddling-helmet-327505?",
	                target: "_blank",
	                style: (_ref3 = {
	                  borderRadius: "4px",
	                  border: "none",
	                  textAlign: "center",
	                  cursor: "pointer",
	                  fontSize: "16px",
	                  msFlexItemAlign: "center",
	                  msGridRowAlign: "center",
	                  alignSelf: "center",
	                  outline: "none",
	                  fontFamily: "inherit",
	                  fontWeight: 500
	                }, _ref3["textAlign"] = "center", _ref3.paddingLeft = "20px", _ref3.paddingRight = "20px", _ref3.height = "45px", _ref3.minWidth = "100px", _ref3.backgroundColor = "inherit", _ref3.color = "#010101", _ref3["border"] = "1px solid #010101", _ref3["fontWeight"] = 600, _ref3.textDecoration = "none", _ref3.paddingTop = "7.5px", _ref3.paddingBottom = "8.5px", _ref3)
	              },
	              "Only available directly from Decathlon"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Gath Surf Convertible: What was the best surf helmet is now just a contender"
	        ),
	        _react2.default.createElement("img", {
	          src: "https://res.cloudinary.com/dx1tmklnq/image/upload/w_1000,c_scale/v1562895626/project_surf_helmet/IMG_20190711_181328_byo5qh.jpg",
	          style: { width: "100%", margin: "0 0 1.5em 0" }
	        }),
	        _react2.default.createElement(
	          "table",
	          null,
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              null,
	              "Pros"
	            ),
	            _react2.default.createElement(
	              "th",
	              null,
	              "Cons"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              null,
	              "Made for surfing"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "Thin layer of EVA = minimal protection"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              null,
	              "Stays on your head with ear covers"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "Even less protection in multiple impacts"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              null,
	              "Low friction, ABS shell"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "Experienced bucket effect without ear covers"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "strong",
	          null,
	          "Recommendation"
	        ),
	        ": Wouldn't recommend it due to it's thin layer of EVA (although I would recommend the",
	        " ",
	        _react2.default.createElement(
	          "a",
	          {
	            target: "_blank",
	            href: "https://www.amazon.com/Gath-Gedi-Helmet-Peak-Black/dp/B00ITT6TV8?&_encoding=UTF8&tag=projectsurfhe-20&linkCode=ur2&linkId=ce7fb36a82fe938ab11a8ae137d27c4e&camp=1789&creative=9325"
	          },
	          "Gath Gedi"
	        ),
	        "). If you can't achieve a better fit with anything else though, it does perform well. Therefore, it's usable - just replace it often. To read why I wouldn't trust such a thin layer of EVA foam to protect your brain read the",
	        " ",
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: "/reviews/gath-surf-converible/" },
	          "full review"
	        ),
	        ". For a little bit better protection try the",
	        " ",
	        _react2.default.createElement(
	          "a",
	          { href: "https://amzn.to/2OfDHqI", target: "_blank" },
	          "Gath Gedi"
	        ),
	        ".",
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              marginTop: "30px",
	              marginBottom: "15px",
	              width: "100%",
	              paddingBottom: "45px",
	              borderBottom: "1px solid #ccc"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            { style: { margin: "0 auto", width: "max-content" } },
	            _react2.default.createElement(
	              "a",
	              {
	                href: "https://gathsports.com/gath-sports-shop/gath-sfc/",
	                target: "_blank",
	                style: (_ref4 = {
	                  borderRadius: "4px",
	                  border: "none",
	                  textAlign: "center",
	                  cursor: "pointer",
	                  fontSize: "16px",
	                  msFlexItemAlign: "center",
	                  msGridRowAlign: "center",
	                  alignSelf: "center",
	                  outline: "none",
	                  fontFamily: "inherit",
	                  fontWeight: 500
	                }, _ref4["textAlign"] = "center", _ref4.paddingLeft = "20px", _ref4.paddingRight = "20px", _ref4.height = "45px", _ref4.minWidth = "100px", _ref4.backgroundColor = "inherit", _ref4.color = "#010101", _ref4["border"] = "1px solid #010101", _ref4["fontWeight"] = 600, _ref4.textDecoration = "none", _ref4.paddingTop = "7.5px", _ref4.paddingBottom = "8.5px", _ref4)
	              },
	              "Order direct"
	            ),
	            _react2.default.createElement(
	              "a",
	              {
	                href: "https://amzn.to/2QldqtW",
	                target: "_blank",
	                style: (_ref5 = {
	                  color: "white",
	                  borderRadius: "4px",
	                  border: "none",
	                  textAlign: "center",
	                  cursor: "pointer",
	                  fontSize: "16px",
	                  msFlexItemAlign: "center",
	                  msGridRowAlign: "center",
	                  alignSelf: "center",
	                  outline: "none",
	                  fontFamily: "inherit",
	                  fontWeight: 500
	                }, _ref5["textAlign"] = "center", _ref5.paddingLeft = "20px", _ref5.paddingRight = "20px", _ref5.height = "47px", _ref5.minWidth = "100px", _ref5.backgroundColor = "#ee5a5a", _ref5.marginLeft = "30px", _ref5["fontWeight"] = 600, _ref5.textDecoration = "none", _ref5.paddingTop = "9px", _ref5.paddingBottom = "10px", _ref5)
	              },
	              "Amazon price"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "h2",
	          null,
	          "1st Runner-up"
	        ),
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Simba Surf Sentinel 1"
	        ),
	        _react2.default.createElement("img", {
	          src: "https://res.cloudinary.com/dx1tmklnq/image/upload/w_1000,c_scale/v1581132019/project_surf_helmet/simba_cover_zyck3o.jpg",
	          style: { width: "100%", margin: "0 0 1.5em 0" }
	        }),
	        _react2.default.createElement(
	          "table",
	          null,
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              null,
	              "Pros"
	            ),
	            _react2.default.createElement(
	              "th",
	              null,
	              "Cons"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              null,
	              "Well-designed for surfing"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "Water drips in eyes"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              null,
	              "Excellent coverage"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "Difficult to achieve ideal fit"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              null,
	              "Light"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "Ultra-thin EVA liner"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "strong",
	          null,
	          "Recommendation"
	        ),
	        ": The Simba Surf Sentinel 1 is a well-designed helmet made for surfing, but lacks the protective-liner necessary to make it on my top list. That being said, all Simba needs to do to make this an exceptional helmet, is update the liner and offer some in-between sizes. I should also mention it works great over wetsuit hoods. Check out my ",
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: "/reviews/simba-sentinel-1/" },
	          "full review"
	        ),
	        ".",
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              marginTop: "30px",
	              marginBottom: "15px",
	              width: "100%",
	              paddingBottom: "45px",
	              borderBottom: "1px solid #ccc"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            { style: { margin: "0 auto", width: "max-content" } },
	            _react2.default.createElement(
	              "a",
	              {
	                href: "https://simbasurf.com/product/sentinel-matte-black-no-side-logo/",
	                target: "_blank",
	                style: (_ref6 = {
	                  borderRadius: "4px",
	                  border: "none",
	                  textAlign: "center",
	                  cursor: "pointer",
	                  fontSize: "16px",
	                  msFlexItemAlign: "center",
	                  msGridRowAlign: "center",
	                  alignSelf: "center",
	                  outline: "none",
	                  fontFamily: "inherit",
	                  fontWeight: 500
	                }, _ref6["textAlign"] = "center", _ref6.paddingLeft = "20px", _ref6.paddingRight = "20px", _ref6.height = "45px", _ref6.minWidth = "100px", _ref6.backgroundColor = "inherit", _ref6.color = "#010101", _ref6["border"] = "1px solid #010101", _ref6["fontWeight"] = 600, _ref6.textDecoration = "none", _ref6.paddingTop = "7.5px", _ref6.paddingBottom = "8.5px", _ref6)
	              },
	              "Order direct"
	            ),
	            _react2.default.createElement(
	              "a",
	              {
	                href: "https://www.amazon.com/Simba-Sentinel-Surf-Helmet-White/dp/B095BYKMHQ?&_encoding=UTF8&tag=projectsurfhe-20&linkCode=ur2&linkId=e20a0295024b9bb81efa0244347af910&camp=1789&creative=9325",
	                target: "_blank",
	                style: (_ref7 = {
	                  color: "white",
	                  borderRadius: "4px",
	                  border: "none",
	                  textAlign: "center",
	                  cursor: "pointer",
	                  fontSize: "16px",
	                  msFlexItemAlign: "center",
	                  msGridRowAlign: "center",
	                  alignSelf: "center",
	                  outline: "none",
	                  fontFamily: "inherit",
	                  fontWeight: 500
	                }, _ref7["textAlign"] = "center", _ref7.paddingLeft = "20px", _ref7.paddingRight = "20px", _ref7.height = "47px", _ref7.minWidth = "100px", _ref7.backgroundColor = "#ee5a5a", _ref7.marginLeft = "30px", _ref7["fontWeight"] = 600, _ref7.textDecoration = "none", _ref7.paddingTop = "9px", _ref7.paddingBottom = "10px", _ref7)
	              },
	              "Amazon price"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "h2",
	          null,
	          "2nd Runner-up"
	        ),
	        _react2.default.createElement(
	          "h3",
	          null,
	          "Ride Engine Barrier Soft Helmet"
	        ),
	        _react2.default.createElement("img", {
	          src: "https://res.cloudinary.com/dx1tmklnq/image/upload/w_1000,c_scale/v1581132019/project_surf_helmet/20220530_173042_nyxuar.jpg",
	          style: { width: "100%", margin: "0 0 1.5em 0" }
	        }),
	        _react2.default.createElement(
	          "table",
	          null,
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              null,
	              "Pros"
	            ),
	            _react2.default.createElement(
	              "th",
	              null,
	              "Cons"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              null,
	              "Fits like a glove"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "Thin layers of EVA"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              null,
	              "Very light"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "No ear protection"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              null,
	              "Sun protection"
	            ),
	            _react2.default.createElement("td", null)
	          )
	        ),
	        _react2.default.createElement(
	          "strong",
	          null,
	          "Recommendation"
	        ),
	        ": A kitesurfing impact hat that also works very well for surfing, the Ride Engine Barrier Soft Helmet is super comfortable, and protects you from the sun. Unfortunately, for impact protection, all it offers is two thin layers of dual-density EVA. The lack of good protection though can easily be remedied by adding your own liner (check my ",
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: "/discreet/" },
	          "discreet page"
	        ),
	        " for ideas - I used the Gamebreaker Stealth Helmet Liner, and cut it to shape). However, after much use, the stretchy, strap mechanism gets worn out, and it no longer stays on while getting pounded. Perhaps try replacing it with a buckle based strap.",
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              marginTop: "30px",
	              marginBottom: "15px",
	              width: "100%",
	              paddingBottom: "45px",
	              borderBottom: "1px solid #ccc"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            { style: { margin: "0 auto", width: "max-content" } },
	            _react2.default.createElement(
	              "a",
	              {
	                href: "https://rideengine.com/products/barrier-soft-helmet",
	                target: "_blank",
	                style: (_ref8 = {
	                  borderRadius: "4px",
	                  border: "none",
	                  textAlign: "center",
	                  cursor: "pointer",
	                  fontSize: "16px",
	                  msFlexItemAlign: "center",
	                  msGridRowAlign: "center",
	                  alignSelf: "center",
	                  outline: "none",
	                  fontFamily: "inherit",
	                  fontWeight: 500
	                }, _ref8["textAlign"] = "center", _ref8.paddingLeft = "20px", _ref8.paddingRight = "20px", _ref8.height = "45px", _ref8.minWidth = "100px", _ref8.backgroundColor = "inherit", _ref8.color = "#010101", _ref8["border"] = "1px solid #010101", _ref8["fontWeight"] = 600, _ref8.textDecoration = "none", _ref8.paddingTop = "7.5px", _ref8.paddingBottom = "8.5px", _ref8)
	              },
	              "Order direct"
	            ),
	            _react2.default.createElement(
	              "a",
	              {
	                href: "https://amzn.to/3HzMGwO",
	                target: "_blank",
	                style: (_ref9 = {
	                  color: "white",
	                  borderRadius: "4px",
	                  border: "none",
	                  textAlign: "center",
	                  cursor: "pointer",
	                  fontSize: "16px",
	                  msFlexItemAlign: "center",
	                  msGridRowAlign: "center",
	                  alignSelf: "center",
	                  outline: "none",
	                  fontFamily: "inherit",
	                  fontWeight: 500
	                }, _ref9["textAlign"] = "center", _ref9.paddingLeft = "20px", _ref9.paddingRight = "20px", _ref9.height = "47px", _ref9.minWidth = "100px", _ref9.backgroundColor = "#ee5a5a", _ref9.marginLeft = "30px", _ref9["fontWeight"] = 600, _ref9.textDecoration = "none", _ref9.paddingTop = "9px", _ref9.paddingBottom = "10px", _ref9)
	              },
	              "Amazon price"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "h2",
	          null,
	          "3rd Runner-up"
	        ),
	        _react2.default.createElement(
	          "h3",
	          null,
	          "DMC Soft Surf Helmet (&V2)"
	        ),
	        _react2.default.createElement("img", {
	          src: "https://res.cloudinary.com/dx1tmklnq/image/upload/w_1000,c_scale/v1581132019/project_surf_helmet/dmc_cover_ubjoxe.jpg",
	          style: { width: "100%", margin: "0 0 1.5em 0" }
	        }),
	        _react2.default.createElement(
	          "table",
	          null,
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              null,
	              "Pros"
	            ),
	            _react2.default.createElement(
	              "th",
	              null,
	              "Cons"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              null,
	              "Designed for surfing"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "Water drips in eyes"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              null,
	              "Extremely light"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "Loose fitting"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              null,
	              "Neck sun protection"
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "Awkward, lace-up back"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "strong",
	          null,
	          "Recommendation"
	        ),
	        ": No different from the",
	        " ",
	        _react2.default.createElement(
	          "a",
	          {
	            target: "_blank",
	            href: "https://www.amazon.com/DMC-Soft-Surf-Helmet-Black/dp/B0C5FZG82B?&_encoding=UTF8&tag=projectsurfhe-20&linkCode=ur2&linkId=8459c6aacaa9dd3502b6db924af6dd71&camp=1789&creative=9325"
	          },
	          "new V2 version"
	        ),
	        ", the DMC Soft Surf Helmet offers low to moderate protection for any size wave. Decent coverage, despite the gaps, and neck sun protection too. Insanely light, but it's so light it's hard to achieve a decent fit. Because of this it's impossible to avoid water dripping in your eyes. However, it works well over wetsuit hoods. The low levels of protection can of course also be easily remedied by adding your own liner (check my",
	        " ",
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: "/discreet/" },
	          "discreet page"
	        ),
	        " for ideas).",
	        " ",
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: "/reviews/dmc-soft-surf-helmet/" },
	          "Full review"
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              marginTop: "30px",
	              marginBottom: "15px",
	              width: "100%",
	              paddingBottom: "45px",
	              borderBottom: "1px solid #ccc"
	            }
	          },
	          _react2.default.createElement(
	            "div",
	            { style: { margin: "0 auto", width: "max-content" } },
	            _react2.default.createElement(
	              "a",
	              {
	                href: "https://dmcfins.com/collections/accessories/products/dmc-soft-surf-helmet-v2-black?variant=40966619627717",
	                target: "_blank",
	                style: (_ref10 = {
	                  borderRadius: "4px",
	                  border: "none",
	                  textAlign: "center",
	                  cursor: "pointer",
	                  fontSize: "16px",
	                  msFlexItemAlign: "center",
	                  msGridRowAlign: "center",
	                  alignSelf: "center",
	                  outline: "none",
	                  fontFamily: "inherit",
	                  fontWeight: 500
	                }, _ref10["textAlign"] = "center", _ref10.paddingLeft = "20px", _ref10.paddingRight = "20px", _ref10.height = "45px", _ref10.minWidth = "100px", _ref10.backgroundColor = "inherit", _ref10.color = "#010101", _ref10["border"] = "1px solid #010101", _ref10["fontWeight"] = 600, _ref10.textDecoration = "none", _ref10.paddingTop = "7.5px", _ref10.paddingBottom = "8.5px", _ref10)
	              },
	              "Order direct"
	            ),
	            _react2.default.createElement(
	              "a",
	              {
	                href: "https://www.amazon.com/DMC-Soft-Surf-Helmet-Black/dp/B0C5FZG82B?&_encoding=UTF8&tag=projectsurfhe-20&linkCode=ur2&linkId=8459c6aacaa9dd3502b6db924af6dd71&camp=1789&creative=9325",
	                target: "_blank",
	                style: (_ref11 = {
	                  color: "white",
	                  borderRadius: "4px",
	                  border: "none",
	                  textAlign: "center",
	                  cursor: "pointer",
	                  fontSize: "16px",
	                  msFlexItemAlign: "center",
	                  msGridRowAlign: "center",
	                  alignSelf: "center",
	                  outline: "none",
	                  fontFamily: "inherit",
	                  fontWeight: 500
	                }, _ref11["textAlign"] = "center", _ref11.paddingLeft = "20px", _ref11.paddingRight = "20px", _ref11.height = "47px", _ref11.minWidth = "100px", _ref11.backgroundColor = "#ee5a5a", _ref11.marginLeft = "30px", _ref11["fontWeight"] = 600, _ref11.textDecoration = "none", _ref11.paddingTop = "9px", _ref11.paddingBottom = "10px", _ref11)
	              },
	              "Amazon price"
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "p",
	        { style: { lineHeight: "1.5rem", margin: "40px 0" } },
	        "Ever wonder how to prevent your lips from getting sunburned? Just so happens that I started wondering that a couple years and started experimenting. Check out my new page on",
	        " ",
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: "/lip-sun-protection/" },
	          "top lip balm sunscreens"
	        ),
	        "."
	      )
	    ),
	    _react2.default.createElement(_Footer2.default, { footnote: data }),
	    _react2.default.createElement(_Seo2.default, { data: data, facebook: facebook, page: true })
	  );
	};
	
	TopThree.propTypes = {
	  classes: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _reactJss2.default)(styles)(TopThree);
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-top-3-js-7c0413872171031533ef.js